export default "__VITE_ASSET__40fcd9ad__"